import {Map} from '../../../components/map/map.tsx';
import {TableRow} from '../../../components/table/table_row.tsx';
import {TableCell} from '../../../components/table/table_cell.tsx';
import {Table} from '../../../components/table/table.tsx';
import {__} from '../../../support/lang/translations.ts';
import {Alignment} from '../../../enums/alignment.ts';
import {FlexRow} from '../../../components/utility/flex_row.tsx';
import {Button} from '../../../components/button/button.tsx';
import {LocationType} from '../../../gql/pwa/graphql.ts';
import {FlexColumn} from '../../../components/utility/flex_column.tsx';
import {HideElement} from '../../../components/utility/hide_element_wrapper.tsx';
import {ShowElement} from '../../../components/utility/show_element_wrapper.tsx';
import {Spacer} from '../../../components/utility/spacer.tsx';

interface OwnProps {
    location: LocationType;
}

export function Address({location}: OwnProps) {
    const suffix = location.house_number_suffix ?? '';
    const fullAddress = `${location.street} ${location.house_number} ${suffix} ${location.postal_code} ${location.country}`;

    return (
        <>
            <Map addressData={fullAddress} />

            <ShowElement size={'sm'}>
                <FlexRow verticalAlignment={Alignment.End}>
                    <span />
                    <Button to={`https://www.google.com/maps/dir/?api=1&destination=${fullAddress}`} target={'_blank'}>
                        <i className="fa-light fa-map" />
                        <span>{__('contact.buttons.map')}</span>
                    </Button>
                </FlexRow>
                <Spacer />
            </ShowElement>

            <FlexRow verticalAlignment={Alignment.Start}>
                <FlexColumn grow={2}>
                    <Table style={{paddingTop: 0}} alignment={Alignment.Start}>
                        <TableRow columns={1}>
                            <TableCell
                                name={__('contact.table.address')}
                                value={`${location.street} ${location.house_number} ${suffix}`}
                            />
                            <TableCell name="" value={`${location.postal_code}`} />
                            <TableCell name="" value={`${location.city}`} />
                            <TableCell name="" value={__(`enums.country.${location.country}`) as string} />
                        </TableRow>
                    </Table>
                </FlexColumn>
                <FlexColumn alignment={Alignment.End}>
                    <HideElement size={'sm'}>
                        <Button
                            to={`https://www.google.com/maps/dir/?api=1&destination=${fullAddress}`}
                            target={'_blank'}
                        >
                            <i className="fa-light fa-map" />
                            <span>{__('contact.buttons.map')}</span>
                        </Button>
                    </HideElement>
                </FlexColumn>
            </FlexRow>
        </>
    );
}
